<template>
  <div class="home">
    <!-- ***********************Intro Home********************** -->
    <div class="position-relative introHome">
      <div class="logo-center d-none">
        <v-img src="@/assets/logos/Logo-martinez-vertical.png" class="img-logo-contadores-intro"></v-img>
      </div>
      <!-- <v-carousel
        v-model="carouselHome"
        :hide-delimiters="true"
        :show-arrows="false"
        height="100vh"
        tile
      >-->
      <!-- <v-carousel-item
          v-for="(image, img) in homeSingleton.carousel"
          transition="change-transition"
          reverse-transition="change-transition"
          :key="img"
      >-->
      <template v-if="isVideo(homeSingleton.imgIntro.path)">
        <video playsinline autoplay muted loop :height="heightVideo" class="principalVideo d-none d-md-block">
          <source type="video/mp4" :src="'https://www.mlcpcms.actstudio.xyz/'+homeSingleton.imgIntro.path" />
        </video>

        <video playsinline autoplay muted loop height="100%" class="principalVideo d-md-none">
          <source type="video/mp4" :src="'https://www.mlcpcms.actstudio.xyz/'+homeSingleton.imgIntro.path" />
        </video>
      </template>
      <template v-else>
        <v-img
          :src="'https://www.mlcpcms.actstudio.xyz/'+homeSingleton.imgIntro.path"
          class="img-intro-home"
        ></v-img>
      </template>
      <!-- </v-carousel-item>
      </v-carousel>-->

      <!-- <div class="arrows" id="arrows">
        <div class="d-flex justify-space-between">
          <div class="cursor-pointer">
            <span @click="carouselHome--">
              <v-icon>mdi-chevron-left</v-icon>
            </span>
          </div>
          <div class="cursor-pointer">
            <span @click="carouselHome++">
              <v-icon>mdi-chevron-right</v-icon>
            </span>
          </div>
        </div>
      </div>-->
    </div>
    <!-- ***********************/Intro Home********************** -->

    <v-container fluid class="py-0">
      <!-- ***********************Bloque sobre nosotros********************** -->
      <v-row class="background-black color-white">
        <v-col cols="12" class="align-self-center pa-8 pa-md-3 home-about-text">
          <div class="div-about-us-home">
            <!-- <span class="subtitles d-block pb-8 bold">Sobre nosotros...</span> -->

            <span
              class="d-block pb-8 text-we-description"
            >
              {{toUpperCase(homeSingleton.weDescription)}}
            </span>

            <router-link to="/about" class="d-block texts white--text link-with-decoration">{{toUpperCase(homeSingleton.weTextLink)}}</router-link>
          </div>
        </v-col>
        <v-col cols="12" class="pa-0 position-relative">
          <div class="container-dots">
            <div
              class="container-dots__dot-home-us"
              v-for="(weImgDot, wid) in homeSingleton.weCover"
              v-bind:key="wid"
              v-bind:class="{'active-dot' : nosotrosCarousel == wid}"
              @click="nosotrosCarousel = wid"
            ></div>
          </div>
          <v-carousel
            v-model="nosotrosCarousel"
            v-bind:hide-delimiter-background="true"
            v-bind:hide-delimiters="true"
            v-bind:show-arrows="false"
            v-bind:cycle="true"
            interval="5000"
            height="100%"
          >
            <v-carousel-item v-for="(weImg, wi) in homeSingleton.weCover" v-bind:key="wi">
              <div>
                <v-img :src="'https://www.mlcpcms.actstudio.xyz/'+weImg.path" class="home-img-rows"></v-img>
              </div>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>

      <!-- ***********************/Bloque sobre nosotros********************** -->
    </v-container>

    <v-container fluid class="py-0">
      <!-- ***********************Bloque servicios********************** -->
      <!-- <v-row>
        <v-col cols="12" md="5" class="align-self-center pa-8 pa-lg-10">
          <div class="div-services-principal">
            <span class="d-block subtitles pb-8 text-center bold">Servicios</span>

            <div class="div-services-home texts">
              <div v-for="(service, srv) in services" :key="srv">
                <router-link :to="'/servicio/'+service.urlService" class="color-black">
                  <span class="uppercase">{{service.textCover}}</span>
                </router-link>
              </div>
            </div>

            <router-link
              to="/servicios"
              class="d-block texts color-black link-with-decoration"
            >Ver más</router-link>
          </div>
        </v-col>

        <v-col cols="12" md="7" class="pa-0">
          <v-img src="@/assets/img/Servicio-portada.jpg" class="home-img-rows"></v-img>
        </v-col>
      </v-row>-->

      <v-row class="row-home__services">
        <v-col cols="12" class="position-relative">
          <div class="arrow-left home-services cursor-pointer" @click="serviceSliderPrev()">
            <!-- <v-icon class="icon-arrow-left-videos">mdi-chevron-left</v-icon> -->
            <v-img src="@/assets/png/flecha.png" class="icon-arrow-left"></v-img>
          </div>

          <div class="arrow-right home-services cursor-pointer" @click="serviceSlideNext()">
            <!-- <v-icon class="icon-arrow-right-videos">mdi-chevron-right</v-icon> -->
            <v-img src="@/assets/png/flecha.png" class="icon-arrow-right"></v-img>
          </div>

          <v-sheet width="100%" color="white">
            <v-slide-group v-model="servicesSlider" center-active>
              <v-slide-item v-for="(service, srv) in services" :key="srv">
                <v-card class="row-home__services--card" tile elevation="0">
                  <v-row>
                    <v-col cols="12">
                      <div class="wrap-columns">
                        <div>
                          <v-img
                            :src="'https://www.mlcpcms.actstudio.xyz/'+service.cover.path"
                            class="img-cover-services__home-services"
                          ></v-img>
                        </div>
                        <div
                          class="overlay-columns"
                          v-bind:class="{'red-column' : service.color == 'red', 'gray-column' : service.color == 'gray', 'black-column' : service.color == 'black', 'blue-column' : service.color == 'blue'}"
                        >
                          <div class="card-position">
                            <div>
                              <v-img
                                :src="'https://www.mlcpcms.actstudio.xyz/'+service.iconCover.path"
                                class="d-block mx-auto img-icon-services__home-services"
                              ></v-img>
                            </div>
                            <div class="text-center">
                              <span
                                class="d-block mt-5 card-title-mine__home uppercase"
                              >{{service.TituloDeServicio}}</span>
                            </div>
                          </div>
                        </div>
                        <div
                          class="overlay2"
                          v-bind:class="{'red-overlay' : service.color == 'red', 'gray-overlay' : service.color == 'gray', 'black-overlay' : service.color == 'black', 'blue-overlay' : service.color == 'blue'}"
                        >
                          <div class="service-description home-description-service">
                            <div class="text-center">
                              <span
                                class="d-block mt-5 card-title-mine__home uppercase"
                              >{{service.TituloDeServicio}}</span>
                            </div>

                            <div class="mt-5 div-description-overlay2">
                              <span class="text-general">{{service.introText}}...</span>
                            </div>

                            <div class="text-center mt-12">
                              <router-link
                                :to="'/servicio/'+service.urlService"
                                class="link-see-more text-general link-with-decoration"
                              >Ver más</router-link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-sheet>
        </v-col>
      </v-row>
      <!-- ***********************/Bloque servicios********************** -->

      <!-- ***********************Bloque contador********************** -->
      <!-- <v-row
        justify="center"
        class="background-blue contador-bloque"
        align="center"
        @scroll="counterFunction"
        id="counterRow"
      >
        <v-col cols="12" md="auto" class="text-center text-md-left">
          <span class="bold subtitles white--text">Experiencia que nos respalda</span>
        </v-col>
        <v-col cols="12" md="4">
          <div class="text-center">
            <div>
              <span class="bold counter">+ {{value}}</span>
            </div>
            <div>
              <span class="experienceYears">Años de experiencia</span>
            </div>
          </div>
        </v-col>
      </v-row> -->

      <v-row class="background-blue row-experience">
        <v-col cols="12">
          <v-img class="img-banner-experience" :src="'https://www.mlcpcms.actstudio.xyz/'+homeSingleton.experienceCover.path"></v-img>
        </v-col>
      </v-row>
      <!-- ***********************/Bloque contador********************** -->

      <!-- ***********************título noticias********************** -->
      <v-row class="background-black text-center">
        <v-col cols="12">
          <h2 class="text-white subtitles">Noticias</h2>
        </v-col>
      </v-row>
      <!-- ***********************/título noticias********************** -->
    </v-container>

    <!-- *****************carousel de noticias****************** -->
    <v-carousel
      v-model="noticiaCarousel"
      v-bind:hide-delimiter-background="true"
      v-bind:hide-delimiters="true"
      v-bind:show-arrows="false"
      height="100%"
      class="carousel-relative-switch"
    >
      <v-carousel-item v-for="(noticia, nt) in noticias" :key="nt">
        <v-row class="background-white">
          <v-col cols="12" md="6" class="pa-0 align-self-center">
            <v-img
              class="img-home-news"
              :src="'https://www.mlcpcms.actstudio.xyz/'+noticia.cover.path"
            ></v-img>
          </v-col>

          <v-col cols="12" md="6" class="noticias-div px-0 my-12 my-md-0 position-relative">
            <v-row>
              <v-col cols="12">
                <div class="px-12 max-width-five">
                  <span class="subtitles">
                    <b>{{noticia.title}}</b>
                  </span>

                  <span class="d-block pt-8 texts">
                    {{noticia.description}}
                    <span>[...]</span>
                  </span>
                  <span>
                    <!-- btn callToAction mobile -->
                    <v-btn
                      class="hidden-md-and-up px-0"
                      :href="noticia.link"
                      elevation="0"
                      tile
                      :ripple="false"
                      target="_blank"
                      text
                    >
                      <span
                        class="texts notUppercase black--text link-with-decoration"
                      >{{noticia.linkName}}</span>
                    </v-btn>
                    <!-- /btn callToAction mobile-->
                  </span>
                </div>
              </v-col>
            </v-row>
            <!-- btn callToAction desk -->
            <v-btn
              class="noticias-enlace hidden-sm-and-down"
              :href="noticia.link"
              elevation="0"
              tile
              color="black"
              :ripple="false"
              target="_blank"
              height="46"
            >
              <span class="texts">{{noticia.linkName}}</span>
            </v-btn>
            <!-- /btn callToAction desk-->
          </v-col>
        </v-row>
      </v-carousel-item>
      <!-- ***************arrows noticias mobile ***************-->
      <div class="arrow-left-news cursor-pointer d-md-none" v-if="noticiaCarousel > 0">
        <v-img
          src="@/assets/png/flecha.png"
          class="icon-arrow-left-news"
          @click="noticiaCarousel--"
        ></v-img>
      </div>
      <div class="arrow-right-news cursor-pointer d-md-none">
        <v-img
          src="@/assets/png/flecha.png"
          class="icon-arrow-right-news"
          @click="noticiaCarousel++"
        ></v-img>
      </div>
      <!-- ***************/arrows noticias mobile *************** -->

      <!-- ***************arrows noticias desk ***************-->
      <div class="arrow-left-news cursor-pointer d-none d-md-block" v-if="noticiaCarousel > 0">
        <!-- <v-icon class="icon-arrow-left-videos">mdi-chevron-left</v-icon> -->
        <v-img
          src="@/assets/png/flecha.png"
          class="icon-arrow-left-news"
          @click="noticiaCarousel--"
        ></v-img>
      </div>
      <div class="arrow-right-news cursor-pointer d-none d-md-block">
        <!-- <v-icon class="icon-arrow-right-videos">mdi-chevron-right</v-icon> -->
        <v-img
          src="@/assets/png/flecha.png"
          class="icon-arrow-right-news"
          @click="noticiaCarousel++"
        ></v-img>
      </div>
      <!-- ***************/arrows noticias desk*************** -->
    </v-carousel>
    <!-- *****************/carousel de noticias desk****************** -->
  </div>
</template>

<script>
export default {
  name: "Home",

  data: () => ({
    //home intro video
    heightVideo: 0,
    carouselHome: 0,
    homeSingleton: {},
    // no se usan
    // interval: {},
    // value: 0,
    noticiaCarousel: 0,

    //us array
    nosotrosCarousel: 0,

    //services array
    services: [],
    servicesSlider: 0,

    //news array
    noticias: [],
  }),
  mounted() {
    // this.counterFunction();
    // no se usa window.addEventListener("scroll", this.counterFunction);

    this.$emit("update", 0);

    //heightVideo
    this.onResize();
    window.addEventListener('resize', this.onResize, {passive:true})
  },
  beforeCreate: function () {
    var aux = this;

    //fetch for the home singleton
    fetch(
      "https://www.mlcpcms.actstudio.xyz/api/singletons/get/home?token=16db21f0656450d15b7ee93d559638",
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((data) => data.json())
      .then((data) => (this.homeSingleton = data));
  },
  created: function () {
    //get the services
    fetch(
      "https://www.mlcpcms.actstudio.xyz/api/collections/get/servicios?token=16db21f0656450d15b7ee93d559638",
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sort: { _created: -1 },
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (this.services = res.entries))
      .catch((error) => console.log(error.message));

    //fetch to get the news
    fetch(
      "https://www.mlcpcms.actstudio.xyz/api/collections/get/noticias?token=16db21f0656450d15b7ee93d559638",
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((res) => (this.noticias = res.entries));
  },
  beforeDestroy() {
    // no se usa  clearInterval(this.interval);

    //remove event listener
    if(typeof window !== "undefined"){
      window.removeEventListener('resize', this.onResize, {passive: true});
    }
  },
  methods: {
    // counterFunction: function (e) { //no se usa
    //   var counterRow = document.getElementById("counterRow");
    //   var position = counterRow.getBoundingClientRect();

    //   if (position.top < 500) {
    //     this.interval = setInterval(() => {
    //       if (this.value === parseInt(this.homeSingleton.experienceCounter)) {
    //         return (this.value = parseInt(
    //           this.homeSingleton.experienceCounter
    //         ));
    //       }

    //       this.value += 1;
    //     }, 500);
    //   }
    // },
    serviceSlideNext: function () {
      this.servicesSlider++;

      if (this.servicesSlider >= this.services.length) {
        this.servicesSlider = 0;
      }
    },
    serviceSliderPrev: function () {
      this.servicesSlider--;

      if (this.servicesSlider < 0) {
        this.servicesSlider = this.services.length - 1;
      }
    },
    isVideo: function (path) {
      return path.substring(path.length - 4) == ".mp4";
    },
    onResize: function(){
      this.heightVideo = window.innerHeight;
    },
    toUpperCase: function(text){
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
  },
};
</script>